import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { Search, User, LogOut, Settings, Moon, Sun, Menu } from 'lucide-react';
import { useAuth } from '../context/AuthContext';
import { useData } from '../context/DataContext';
import { useTheme } from '../context/ThemeContext';

const Header = ({ onToggleSidebar }) => {
  const [searchQuery, setSearchQuery] = useState('');
  const [searchResults, setSearchResults] = useState([]);
  const [showResults, setShowResults] = useState(false);
  const { user, logout, isAdmin, isAuthor } = useAuth();
  const { searchContent } = useData();
  const { isDark, toggleTheme } = useTheme();
  const navigate = useNavigate();

  const handleSearch = (query) => {
    setSearchQuery(query);
    if (query.trim()) {
      const results = searchContent(query);
      setSearchResults(results);
      setShowResults(true);
    } else {
      setShowResults(false);
    }
  };

  const handleResultClick = (scriptId) => {
    navigate(`/script/${scriptId}`);
    setShowResults(false);
    setSearchQuery('');
  };

  const handleLogout = () => {
    logout();
    navigate('/');
  };

  return (
    <header className="header">
      <div className="header-left">
        <button className="hamburger-btn" onClick={onToggleSidebar}>
          <Menu size={24} />
        </button>
        <Link to="/" style={{ textDecoration: 'none', color: 'inherit' }}>
          <h1 style={{ 
            fontWeight: '700', 
            fontSize: '1.5rem', 
            letterSpacing: '0.5px',
            fontFamily: '-apple-system, BlinkMacSystemFont, "Segoe UI", "Roboto", sans-serif'
          }}>MSSQLDBATeam.com</h1>
        </Link>
      </div>
      
      <div className="header-actions">
        <button onClick={toggleTheme} className="theme-toggle">
          {isDark ? <Sun size={20} /> : <Moon size={20} />}
        </button>
        
        <div className="search-container">
          <input
            type="text"
            placeholder="Search scripts..."
            className="search-input"
            value={searchQuery}
            onChange={(e) => handleSearch(e.target.value)}
            onBlur={() => setTimeout(() => setShowResults(false), 200)}
          />
          <Search className="search-icon" size={18} />
          
          {showResults && searchResults.length > 0 && (
            <div className="search-results">
              {searchResults.slice(0, 5).map(script => (
                <div
                  key={script.id}
                  className="search-result-item"
                  onClick={() => handleResultClick(script.id)}
                >
                  <div className="result-title">{script.title}</div>
                  <div className="result-category">{script.category} - {script.subcategory}</div>
                </div>
              ))}
            </div>
          )}
        </div>

        {user ? (
          <div className="user-menu">
            {user.avatar_url ? (
              <img src={user.avatar_url} alt="" className="header-avatar" />
            ) : (
              <User size={20} />
            )}
            <span>{user.full_name || user.name || user.username}</span>
            {(isAdmin || isAuthor) && (
              <Link to="/admin" className="admin-link" title={isAdmin ? 'Admin panel' : 'Author panel'}>
                <Settings size={16} />
              </Link>
            )}
            <button onClick={handleLogout} className="logout-btn">
              <LogOut size={16} />
            </button>
          </div>
        ) : (
          <div className="auth-header-links">
            <Link to="/register" className="login-link register-link">
              Sign up
            </Link>
            <Link to="/login" className="login-link">
              Login
            </Link>
          </div>
        )}
      </div>
    </header>
  );
};

export default Header;